import api from "@/config/apiConfig"

class ContactsController {
  async index ( req ) {
    try {
      const response = await api.get( "/contact", { params: { ...req }})
      response.data.contacts.forEach( item => {
        if ( item.additionalInfo ) {
          item.text = `${ item.name } - ${ item.additionalInfo }`;
        } else {
          item.text = item.name;
        }
      });
      return response.data
    } catch ( error ) {
      console.error( "Erro no ContactsController.view: ", error )
      throw error
    }
  }
  async create ( req ) {
    try {
      const response = await api.post( "/contact", req )
      return response.data
    } catch ( error ) {
      console.error( "Erro no ContactsController.create: ", error )
      throw error
    }
  }
  async update ( req ) {
    try {
      const response = await api.patch( `/contact/${ req.id }`, req )
      return response.data
    } catch ( error ) {
      console.error( "Erro no ContactsController.update: ", error )
      throw error
    }
  }
  async delete ( req ) {
    try {
      const response = await api.delete( `/contact/${ req.id }` )
      return response.data
    } catch ( error ) {
      console.error( "Erro no ContactsController.delete: ", error )
      throw error
    }
  }
  async get ( req ) {
    try {
      const response = await api.get( `/contact/${ req.id }` )
      return response.data
    } catch ( error ) {
      console.error( "Erro no ContactsController.get: ", error )
      throw error
    }
  }

  async syncWuzapi () {
    try {
      const response = await api.post( `/contact/sync-wuzapi` )
      return response.data
    } catch ( error ) {
      console.error( "Erro no ContactsController.syncWuzapi: ", error )
      throw error
    }
  }

  async bulkImport ( contacts ) {
    try {
      const response = await api.post( `/contact/bulk-import`, { contacts } )
      return response.data
    } catch ( error ) {
      console.error( "Erro no ContactsController.bulkImport: ", error )
      throw error
    }
  }
}

export default new ContactsController()
